// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';
import Star from './atoms/star';

const Container = styled<any, Theme>('div')`
  display: flex;
`;

const BigStar = styled<typeof Star, Theme, _>(Star)`
  font-size: 0.4em;
  top: 0.7em;
`;

const Stars = () => (
  <Container>
    <Star />
    <BigStar />
    <Star />
  </Container>
);

export default Stars;
